'use client';

import { useStore } from '@libs/common-next';
import { stringifyStoreId } from '@libs/core';

import { useProduct } from '@/entities/product';

import { FBTForm } from './FBTForm';

import './FrequentlyBoughtTogether.scss';

export function FrequentlyBoughtTogether() {
    const { selectedStoreId } = useStore();
    const { product: selectedProduct } = useProduct();

    if (!selectedStoreId || !selectedProduct?.deliveryMethods.BOPIS.availablePurchaseOptions?.oneTime) {
        return null;
    }

    const storeId = stringifyStoreId(selectedStoreId) as string;

    return <FBTForm storeId={storeId} selectedProduct={selectedProduct} />;
}
